import { render, staticRenderFns } from "./FBreakpoint.vue?vue&type=template&id=597be804&"
import script from "./FBreakpoint.vue?vue&type=script&lang=js&"
export * from "./FBreakpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports